import React from 'react';
import DeveloperPlatformIcon from './logo/dpp-icon.png';

const LogoIcon = () => {
  return <img src={DeveloperPlatformIcon} width="auto" height="45" />;
};

export default LogoIcon;
